import React from 'react';
import PropTypes from 'prop-types';

import BlockSection from '~/components/wrappers/BlockSection';

import Row from '~/layout/Row';
import Column from '~/layout/Column';

import {
    GlobalBlockOptions,
    AcfAttributes,
    DefaultGlobalBlockOptions,
    DefaultAcfAttributes
} from '~/utilities/propTypes';
import CtaCard from '~/components/cards/CtaCard';

const CtaCards = ({
    attributes = DefaultAcfAttributes,
    globalBlockOptions = DefaultGlobalBlockOptions,
    cards
}) => {
    return (
        <BlockSection
            backgroundColor="lightBlue"
            padding="medium"
            {...{ globalBlockOptions, attributes }}
        >
            <Row>
                {cards.map((card) => (
                    <Column
                        key={card.title}
                        span={12}
                        spanTablet={6}
                        spanDesktop={4}
                    >
                        <CtaCard {...card} />
                    </Column>
                ))}
            </Row>
        </BlockSection>
    );
};

CtaCards.propTypes = {
    attributes: AcfAttributes,
    globalBlockOptions: GlobalBlockOptions,
    cards: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            subtitle: PropTypes.string,
            icon: PropTypes.string.isRequired,
            link: PropTypes.shape({
                uri: PropTypes.string.isRequired
            }).isRequired
        })
    ).isRequired
};

export default CtaCards;
